import React from 'react';
import { ChameleonCTALink } from '../Link';
import styled from 'styled-components';
import { typography, media } from '../../lib/styles';

export interface Props {
    phoneNumber: string;
}

const StyledPhoneNumber = styled.div`
    display: inline;
    font-family: ${typography.fontFamilies.links.jumbo};
    font-size: ${typography.fontSizes.links.jumbo}px;
`;

const Number = styled.span`
    @media ${media('small')} {
        display: none;
    }
`;

const LinkWrapper = styled.div`
    display: none;
    @media ${media('small')} {
        display: inline;
    }
`;

function PhoneNumber({ phoneNumber }: Props) {
    return (
        <StyledPhoneNumber>
            <Number>{phoneNumber}</Number>
            <LinkWrapper>
                <ChameleonCTALink href={`tel:${phoneNumber}`} data-testid="phone-link">
                    {phoneNumber}
                </ChameleonCTALink>
            </LinkWrapper>
        </StyledPhoneNumber>
    );
}

export default PhoneNumber;
